import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import AdminImageUploadModal from './AdminImageUploadModal'

let ReactQuill = null

if (typeof window !== 'undefined') {
  ReactQuill = require('react-quill')
}

const ToolbarWrapper = styled.div`
  border-bottom: 0;

  .ql-soundcloud svg {
    width: 100%;
  }
`

const Toolbar = () => (
  <ToolbarWrapper id="toolbar">
    <button className="ql-bold" />
    <button className="ql-italic" />
    <button className="ql-underline" />
    <button className="ql-blockquote" />
    <button value="ordered" className="ql-list" />
    <button value="bullet" className="ql-list" />
    <button className="ql-link" />
    <button className="ql-image" />
    <button className="ql-video" />
    <button className="ql-soundcloud">
      <svg viewBox="0 208.952 1048.713 581.696">
        <path d="M0 686.216c0 13.014 4.718 22.854 14.152 29.524 9.435 6.669 19.52 9.027 30.256 7.076 10.085-1.952 17.161-5.531 21.229-10.736 4.066-5.205 6.1-13.827 6.1-25.864v-141.52c0-10.086-3.497-18.626-10.492-25.62-6.994-6.995-15.534-10.492-25.62-10.492-9.76 0-18.137 3.497-25.132 10.492C3.498 526.07 0 534.61 0 544.696v141.52zm112.24 60.512c0 9.436 3.335 16.511 10.004 21.229 6.67 4.718 15.21 7.076 25.62 7.076 10.736 0 19.438-2.359 26.108-7.076 6.669-4.717 10.004-11.793 10.004-21.229V416.84c0-9.76-3.498-18.138-10.492-25.132-6.995-6.994-15.535-10.492-25.62-10.492-9.76 0-18.138 3.498-25.132 10.492-6.995 6.995-10.492 15.372-10.492 25.132v329.888zm111.752 15.616c0 9.435 3.416 16.511 10.248 21.229 6.832 4.717 15.616 7.076 26.353 7.076 10.41 0 18.95-2.359 25.619-7.076 6.67-4.718 10.005-11.794 10.005-21.229V461.248c0-10.085-3.498-18.707-10.492-25.864-6.995-7.157-15.372-10.735-25.132-10.735-10.086 0-18.707 3.578-25.864 10.735s-10.736 15.779-10.736 25.864v301.096zm112.24 1.464c0 17.894 12.037 26.841 36.112 26.841 24.074 0 36.111-8.947 36.111-26.841v-488c0-27.328-8.296-42.781-24.888-46.36-10.736-2.603-21.31.488-31.72 9.272-10.411 8.784-15.616 21.146-15.616 37.088v488zm114.193 14.152V247.016c0-16.917 5.042-27.002 15.128-30.256 21.797-5.205 43.432-7.808 64.904-7.808 49.775 0 96.136 11.712 139.079 35.136 42.944 23.424 77.674 55.388 104.188 95.892 26.515 40.505 41.887 85.156 46.116 133.957 19.845-8.459 40.991-12.688 63.439-12.688 45.547 0 84.506 16.104 116.876 48.312 32.371 32.209 48.557 70.923 48.557 116.145 0 45.547-16.186 84.424-48.557 116.632-32.37 32.208-71.166 48.312-116.388 48.312l-424.56-.488c-2.929-.976-5.125-2.766-6.589-5.368s-2.193-4.882-2.193-6.834z" className="ql-fill" />
      </svg>
    </button>
    <button className="ql-clean" />
  </ToolbarWrapper>
)

export default class AdminWYSIWYG extends React.Component {
  constructor () {
    super()
    this.modules = {
      toolbar: {
        container: '#toolbar',
        handlers: {
          soundcloud: this.handleSoundCloud.bind(this),
          image: this.toggleImageModal.bind(this),
        },
      },
    }
    this.state = {
      imageModal: false,
      imageUrl: null,
      imageAlt: '',
    }
    this.toggleImageModal = this.toggleImageModal.bind(this)
    this.handleFormChange = this.handleFormChange.bind(this)
    this.updateImageData = this.updateImageData.bind(this)

    if (typeof window !== 'undefined') {
      this.blockEmbed = require('./AdminWYSIWYGBlockEmbed')
    }
  }

  componentWillUpdate (nextProps, nextState) {
    if (nextState.imageUrl !== this.state.imageUrl) {
      this.handleImage(nextState.imageUrl)
    }
  }

  handleSoundCloud () {
    if (typeof window === 'undefined') return
    const editor = this.reactQuill.getEditor()
    const quill = ReactQuill.Quill
    const range = editor.getSelection(true)
    const url = prompt('Enter Soundcloud Embed Url')
    if (url) {
      const obj = {}
      obj.width = url.substring(url.indexOf('width=')+7).split('"')[0]
      obj.height = url.substring(url.indexOf('height=')+8).split('"')[0]
      obj.src = url.substring(url.indexOf('src=')+5).split('"')[0]
      editor.insertEmbed(range.index, 'soundcloud', obj, quill.sources.USER)
      editor.setSelection(range.index + 2, quill.sources.SILENT)
    }
  }
  handleImage (url) {
    if (typeof window === 'undefined') return
    const editor = this.reactQuill.getEditor()
    const quill = ReactQuill.Quill
    const range = editor.getSelection(true)
    editor.insertEmbed(range.index, 'image', url, quill.sources.USER)
    editor.setSelection(range.index + 2, quill.sources.SILENT)
  }
  toggleImageModal () {
    this.setState(prev => ({ imageModal: !prev.imageModal }))
  }
  handleFormChange (e) {
    const name = e.target.name
    const value = e.target.value
    this.setState({ [name]: value })
  }
  updateImageData (url, alt, cb) {
    this.setState({
      imageUrl: url,
      imageAlt: alt,
    })
    cb(this.toggleImageModal)
  }
  render () {
    const { imageModal, imageAlt } = this.state
    const { className, value, onChange } = this.props
    return (
      typeof window !== 'undefined'
        ? <div className="text-editor">
          <Toolbar />
          <ReactQuill
            ref={el => this.reactQuill = el}
            modules={this.modules}
            theme="snow"
            value={value}
            onChange={onChange}
            className={className} />
          {imageModal &&
            <AdminImageUploadModal
              className="modal is-active"
              alt={imageAlt}
              handleFormChange={this.handleFormChange}
              toggleImageModal={this.toggleImageModal}
              updateImageData={this.updateImageData}
              param="editor" />}
          </div>
        : <textarea />
    )
  }
}

AdminWYSIWYG.propTypes = {
  className: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminWYSIWYG.js